import { useHttpClient } from "@/common/api/httpClient";
import { useLanguageStore } from "shared/translations/stores/languageStore";
import { storeToRefs } from "pinia";
import type { CoilResponse } from "./common/coilResponse";
import { useCoilStore } from "shared/coils/stores/coilStore";
import type { StorageAreaResponse } from "@/storageAreas/api/models/storageAreaResponse";
import { useStorageAreaStore } from "shared/storageAreas/stores/storageAreaStore";

export interface CreateCoilRequest {
  coil: Coil;
}

export interface Coil {
  name: string;
  diameter: number;
  depth: number|null;
  productId: string;
  storageAreaId: string;
  position: number;
  level: number;
}

export interface CreateCoilResponse {
  coil: CoilResponse;
  storageArea: StorageAreaResponse;
}

export function useCreateCoil() {

  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);
  const store = useCoilStore();
  const storageAreaStore = useStorageAreaStore();

  return {
    execute
  };

  async function execute(action: CreateCoilRequest) {
    const {
      coil,
    } = action;

    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl('coil'), {
      method: 'POST',
      headers,
      body: JSON.stringify(coil)
    });

    const text = translations.value.coils.actions.create;

    const response = await httpClient.action(request, {
      title: text.title,
      errorTitle: text.error,
      async processOk(response) {
        const json = await response.json() as CreateCoilResponse;
        store.add(json.coil);
        storageAreaStore.add(json.storageArea);
        return {
          ok: true,
          coil: json.coil
        };
      },
    });

    return response;
  }
}


